var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconvid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 105,
    viewBox: "0 0 163 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2489_11178)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2489_11178",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C12 15.5817 15.5817 12 20 12H142.549C146.968 12 150.549 15.5817 150.549 20V71.0084C150.549 75.4267 146.968 79.0084 142.549 79.0084H98.753C96.8574 79.0084 95.3207 80.5451 95.3207 82.4407C95.3207 84.3363 96.8574 85.873 98.753 85.873H109.269C111.17 85.873 112.71 87.4138 112.71 89.3143C112.71 91.2149 111.17 92.7556 109.269 92.7556H53.2538C51.3532 92.7556 49.8125 91.2149 49.8125 89.3143C49.8125 87.4138 51.3532 85.873 53.2538 85.873H64.2747C66.1703 85.873 67.707 84.3363 67.707 82.4407C67.707 80.5451 66.1703 79.0084 64.2747 79.0084H20C15.5817 79.0084 12 75.4267 12 71.0084V20Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C12 15.5817 15.5817 12 20 12H142.549C146.968 12 150.549 15.5817 150.549 20V71.0084C150.549 75.4267 146.968 79.0084 142.549 79.0084H98.753C96.8574 79.0084 95.3207 80.5451 95.3207 82.4407C95.3207 84.3363 96.8574 85.873 98.753 85.873H109.269C111.17 85.873 112.71 87.4138 112.71 89.3143C112.71 91.2149 111.17 92.7556 109.269 92.7556H53.2538C51.3532 92.7556 49.8125 91.2149 49.8125 89.3143C49.8125 87.4138 51.3532 85.873 53.2538 85.873H64.2747C66.1703 85.873 67.707 84.3363 67.707 82.4407C67.707 80.5451 66.1703 79.0084 64.2747 79.0084H20C15.5817 79.0084 12 75.4267 12 71.0084V20Z",
    fill: "#EFF4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.549 11.6725H20V12.3275H142.549V11.6725ZM150.877 71.0084V20H150.222V71.0084H150.877ZM98.753 79.336H142.549V78.6809H98.753V79.336ZM98.753 86.2006H109.269V85.5455H98.753V86.2006ZM109.269 92.4281H53.2538V93.0832H109.269V92.4281ZM53.2538 86.2006H64.2747V85.5455H53.2538V86.2006ZM20 79.336H64.2747V78.6809H20V79.336ZM11.6725 20V71.0084H12.3275V20H11.6725ZM20 78.6809C15.7626 78.6809 12.3275 75.2458 12.3275 71.0084H11.6725C11.6725 75.6076 15.4008 79.336 20 79.336V78.6809ZM68.0346 82.4407C68.0346 80.3642 66.3512 78.6809 64.2747 78.6809V79.336C65.9894 79.336 67.3795 80.726 67.3795 82.4407H68.0346ZM64.2747 86.2006C66.3512 86.2006 68.0346 84.5173 68.0346 82.4407H67.3795C67.3795 84.1555 65.9894 85.5455 64.2747 85.5455V86.2006ZM50.14 89.3143C50.14 87.5947 51.5341 86.2006 53.2538 86.2006V85.5455C51.1723 85.5455 49.485 87.2329 49.485 89.3143H50.14ZM53.2538 92.4281C51.5341 92.4281 50.14 91.034 50.14 89.3143H49.485C49.485 91.3958 51.1723 93.0832 53.2538 93.0832V92.4281ZM112.383 89.3143C112.383 91.034 110.989 92.4281 109.269 92.4281V93.0832C111.35 93.0832 113.038 91.3958 113.038 89.3143H112.383ZM109.269 86.2006C110.989 86.2006 112.383 87.5947 112.383 89.3143H113.038C113.038 87.2329 111.35 85.5455 109.269 85.5455V86.2006ZM94.9931 82.4407C94.9931 84.5173 96.6765 86.2006 98.753 86.2006V85.5455C97.0383 85.5455 95.6482 84.1555 95.6482 82.4407H94.9931ZM98.753 78.6809C96.6765 78.6809 94.9931 80.3642 94.9931 82.4407H95.6482C95.6482 80.726 97.0383 79.336 98.753 79.336V78.6809ZM150.222 71.0084C150.222 75.2458 146.787 78.6809 142.549 78.6809V79.336C147.149 79.336 150.877 75.6076 150.877 71.0084H150.222ZM20 11.6725C15.4008 11.6725 11.6725 15.4008 11.6725 20H12.3275C12.3275 15.7626 15.7626 12.3275 20 12.3275V11.6725ZM142.549 12.3275C146.787 12.3275 150.222 15.7626 150.222 20H150.877C150.877 15.4008 147.149 11.6725 142.549 11.6725V12.3275Z",
    fill: "#D2DAE7",
    mask: "url(#path-1-inside-1_2489_11178)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_2489_11178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.617,
    y: 75.7734,
    width: 131.016,
    height: 60.5427,
    rx: 5,
    transform: "rotate(-180 146.617 75.7734)",
    fill: "#EFF4F8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_2489_11178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.6094,
    y: 28,
    width: 78.75,
    height: 35.6736,
    rx: 4,
    fill: "#EFF4F8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_2489_11178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.398 41.2737C92.0336 41.129 91.629 41.0819 91.2345 41.1383C90.84 41.1947 90.473 41.3521 90.1791 41.5909L87.6004 43.7059V42.1725C87.6004 41.3311 87.2213 40.5242 86.5465 39.9292C85.8717 39.3342 84.9565 39 84.0022 39H73.2076C72.2533 39 71.3381 39.3342 70.6633 39.9292C69.9885 40.5242 69.6094 41.3311 69.6094 42.1725V50.6327C69.6094 51.4741 69.9885 52.281 70.6633 52.876C71.3381 53.4709 72.2533 53.8052 73.2076 53.8052H84.0022C84.9565 53.8052 85.8717 53.4709 86.5465 52.876C87.2213 52.281 87.6004 51.4741 87.6004 50.6327V49.0993L90.1911 51.2143C90.5725 51.5187 91.0679 51.6882 91.5824 51.6902C91.8679 51.6896 92.15 51.6355 92.41 51.5315C92.7637 51.4054 93.0668 51.1891 93.2804 50.9103C93.4941 50.6315 93.6086 50.3029 93.6094 49.9664V42.8388C93.6076 42.5011 93.4913 42.1716 93.2755 41.8927C93.0596 41.6138 92.754 41.3982 92.398 41.2737Z",
    fill: "#4770DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2489_11178",
    x: 0,
    y: 0,
    width: 162.551,
    height: 104.754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2489_11178"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.718924 0 0 0 0 0.780295 0 0 0 0 0.841667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2489_11178",
    result: "effect2_dropShadow_2489_11178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2489_11178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_2489_11178",
    x: 12.6016,
    y: 12.2305,
    width: 138.016,
    height: 67.543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.729601 0 0 0 0 0.793893 0 0 0 0 0.854167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_11178"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_11178",
    result: "effect2_innerShadow_2489_11178"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_2489_11178",
    x: 30.6094,
    y: 16,
    width: 102.75,
    height: 59.6719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2489_11178"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.718924 0 0 0 0 0.780295 0 0 0 0 0.841667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2489_11178",
    result: "effect2_dropShadow_2489_11178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2489_11178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_2489_11178",
    x: 46.3116,
    y: 15.7022,
    width: 63.315,
    height: 54.1197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.36834,
    dy: 4.36834
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.82445
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.652778 0 0 0 0 0.706536 0 0 0 0 0.783333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2489_11178"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.82445,
    dy: -5.82445
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.73667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2489_11178",
    result: "effect2_dropShadow_2489_11178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2489_11178",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconvid);
export default __webpack_public_path__ + "static/media/iconvid.53f6b7596a8ae6fbb86431440ba8dbf8.svg";
export { ForwardRef as ReactComponent };